<button class="button primary-button" (click)="addSubstitute()" [attr.data-test-id]="[testId, 'add_substitute'].join('_')">
  {{ 'module.substitute.text.add-substitution' | translate }}
</button>
<span id="table_descr" style="display: none;">Substitute table</span>
<div class="mt-2 example-container">
  <table mat-table [dataSource]="substitutes" class="w-100" aria-describedby="table_descr">
    <ng-container matColumnDef="user">
      <th scope="col" mat-header-cell *matHeaderCellDef>{{ 'module.substitute.substitute-list.affected-user' | translate }}</th>
      <td mat-cell *matCellDef="let element">
        <span class="fs-sm">{{ utilsService.getFullUserName(element.user) }}</span>
      </td>
    </ng-container>

    <ng-container matColumnDef="substituteUser">
      <th scope="col" mat-header-cell *matHeaderCellDef>{{ 'module.substitute.substitute-list.delegate' | translate }}</th>
      <td mat-cell *matCellDef="let element">
        <span class="fs-sm">{{ utilsService.getFullUserName(element.substituteUser) }}</span>
      </td>
    </ng-container>

    <ng-container matColumnDef="requestor">
      <th scope="col" mat-header-cell *matHeaderCellDef>{{ 'module.substitute.substitute-list.requestor' | translate }}</th>
      <td mat-cell *matCellDef="let element">
        <span class="fs-sm">{{ utilsService.getFullUserName(element.requestor) }}</span>
      </td>
    </ng-container>

    <ng-container matColumnDef="startDate">
      <th scope="col" mat-header-cell *matHeaderCellDef>{{ 'module.substitute.substitute-list.start-date' | translate }}</th>
      <td mat-cell *matCellDef="let element">
        <span class="fs-sm">{{ element.startDate | date: 'MM/dd/yyyy':null }}</span>
      </td>
    </ng-container>

    <ng-container matColumnDef="endDate">
      <th scope="col" mat-header-cell *matHeaderCellDef>{{ 'module.substitute.substitute-list.end-date' | translate }}</th>
      <td mat-cell *matCellDef="let element">
        <span class="fs-sm">{{ element.endDate | date: 'MM/dd/yyyy':null }}</span>
      </td>
    </ng-container>

    <ng-container matColumnDef="actions" stickyEnd>
      <th scope="col" mat-header-cell *matHeaderCellDef></th>
      <td mat-cell *matCellDef="let element; let i = index" class="text-right">
        <button mat-icon-button [attr.data-test-id]="['susbsitute_list', i, 'edit'].join('_')" (click)="editSubstitute(element)">
          <mat-icon class="color-navi">edit</mat-icon>
        </button>

        <button mat-icon-button [attr.data-test-id]="['susbsitute_list', i, 'delete'].join('_')" (click)="removeSubstitute(element)">
          <mat-icon class="color-navi">delete</mat-icon>
        </button>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
  </table>

  <ng-content></ng-content>
</div>
